module.exports = __webpack_public_path__ + "img/game_icon_red.4b9ebedc.png";